import React from 'react'

import Button from "../../../../core/gd-components/buttons/gd-button/gd-button-ui5-new"

type Props = {
    onNewRequest: {():void}
}

export default function RequestFormSubmissionConfirmation(props:Props) {
    return (
        <div className="confirmation">
            <div className="message">
                Your request has been successfully sent.
            </div>

            <Button className   = "w-150"
                    type        = "primary"
                    size        = "36"
                    label       = "New request"
                    onClick     = {props.onNewRequest} />
        </div>
    )
}
